// Auto-generated carousel images utility
// This file is automatically generated by scripts/generateCarouselImports.js
// To regenerate, run: npm run generate-carousel-imports

import image1 from '../assets/carouselImages/2026_01.jpg';
import image2 from '../assets/carouselImages/2026_02.jpg';
import image3 from '../assets/carouselImages/2026_03.jpg';
import image4 from '../assets/carouselImages/2026_04.jpg';
import image5 from '../assets/carouselImages/2026_05.jpg';
import image6 from '../assets/carouselImages/2026_06.png';
import image7 from '../assets/carouselImages/2026_07.jpg';
import image8 from '../assets/carouselImages/2026_08.jpg';
import image9 from '../assets/carouselImages/2026_09.jpg';
import image10 from '../assets/carouselImages/2026_10.jpg';
import image11 from '../assets/carouselImages/2026_11.jpg';
import image12 from '../assets/carouselImages/2026_12.jpg';
import image13 from '../assets/carouselImages/2026_13.jpg';
import image14 from '../assets/carouselImages/2026_14.jpg';
import image15 from '../assets/carouselImages/2026_15.jpg';
import image16 from '../assets/carouselImages/2026_16.jpg';
import image17 from '../assets/carouselImages/2026_17.jpg';
import image18 from '../assets/carouselImages/2026_18.jpg';
import image19 from '../assets/carouselImages/2026_19.jpg';
import image20 from '../assets/carouselImages/2026_20.jpg';
import image21 from '../assets/carouselImages/2026_21.jpg';
import image22 from '../assets/carouselImages/2026_22.jpg';
import image23 from '../assets/carouselImages/2026_23.jpg';
import image24 from '../assets/carouselImages/2026_24.jpg';
import image25 from '../assets/carouselImages/2026_25.jpg';
import image26 from '../assets/carouselImages/2026_26.jpg';
import image27 from '../assets/carouselImages/2026_27.jpg';
import image28 from '../assets/carouselImages/2026_28.jpg';
import image29 from '../assets/carouselImages/2026_29.jpg';
import image30 from '../assets/carouselImages/2026_30.jpg';
import image31 from '../assets/carouselImages/2026_31.jpg';
import image32 from '../assets/carouselImages/2026_32.jpg';
import image33 from '../assets/carouselImages/2026_33.jpg';
import image34 from '../assets/carouselImages/2026_34.jpg';
import image35 from '../assets/carouselImages/2026_35.jpg';

// Simple list of carousel images
export const carouselImages = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image25,
  image26,
  image27,
  image28,
  image29,
  image30,
  image31,
  image32,
  image33,
  image34,
  image35
];

export const getCarouselImages = async (): Promise<string[]> => {
  try {
    return carouselImages;
  } catch (error) {
    console.error('Error loading carousel images:', error);
    throw error;
  }
};

// Helper function to get image count
export const getImageCount = (): number => {
  return carouselImages.length;
};

// Helper function to get image by index
export const getImageByIndex = (index: number): string | null => {
  return carouselImages[index] || null;
};
